import {ValueObject} from '@s-ui/domain'

import {NumberSharedValueObject} from '../../shared/ValueObjects/NumberSharedValueObject.js'
import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'

export class RatingFeatureValueObject extends ValueObject {
  #type
  #label
  #score

  constructor({type, label, score}) {
    super()
    this.#type = type
    this.#label = label
    this.#score = score
  }

  get type() {
    return this.#type.value
  }

  get label() {
    return this.#label.value
  }

  get score() {
    return this.#score.value
  }

  get value() {
    return {
      type: this.#type.value,
      label: this.#label.value,
      score: this.#score.value
    }
  }

  static createFromPrimitives({type, label, score}) {
    return new RatingFeatureValueObject({
      type: StringSharedValueObject.create({value: type}),
      label: StringSharedValueObject.create({value: label}),
      score: NumberSharedValueObject.create({value: score})
    })
  }
}
